import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
  const siteTitle = "Sohani Handicrafts";
  const fullTitle = `${title} | ${siteTitle}`;
  const siteUrl = "https://www.sohanihandicrafts.com"; // Your live domain
  const defaultDesc = "Premium handcrafted wooden furniture and artisan decor from Jodhpur, India. Explore our Factory Wood and Marble collections.";

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta name="keywords" content={keywords || "handicrafts, wood furniture, jodhpur handicrafts, artisan wood, industrial iron furniture"} />
      <link rel="canonical" href={`${siteUrl}${url || ""}`} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:image" content={image || "/logo-og.png"} />
      <meta property="og:url" content={`${siteUrl}${url || ""}`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
      <meta name="twitter:image" content={image || "/logo-og.png"} />
    </Helmet>
  );
};

export default SEO;